
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M43.652 12.345a2.086 2.086 0 00-2.087-2.086 4.172 4.172 0 00-4.174 4.172 6.26 6.26 0 006.261 6.259 8.345 8.345 0 100-16.69H12.348A8.344 8.344 0 004 12.345a8.347 8.347 0 008.348 8.345 6.26 6.26 0 006.26-6.259 4.17 4.17 0 00-4.173-4.172 2.086 2.086 0 00-2.087 2.086m6.229 6.275V52m18.782-33.38V52M24.837 18.62V52m6.261-33.38V52M17.01 18.62h22.043M18.577 14.415h18.782"}})])])
          )
        }
      }
    